<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-4.basic100
          v-row(no-gutters)
            v-col
              p.mb-0.h6.basic800--text {{ $t('manage_shipping') }}
              
        v-divider.basic200
        .selectionLayout.pa-4(v-if="!selectedCourierCompany")
          div.s1.textColorMethod--text {{ $t('select_shipping_method') }}
          v-card.mt-4.elevation-0(style="border:1px solid var(--v-basic300)")
            v-list.pa-0
              div(v-for='(selection, index) in courierCompanySelections')
                v-divider.basic300(v-if="index != 0")
                v-list-item(:key='selection.id' @click="selectedCourierCompany = selection.id")
                  v-layout(style="height: 56px")
                    div.my-auto
                      v-img(:src="selection.image" width=32, height=32)
                    v-col.mx-2.my-auto
                      div {{ selection.id | shippingMethodDisplay }}
              v-divider.basic300(v-if="courierCompanySelections.length > 0")

        v-layout.pa-5(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        v-card-text.pa-0(v-else-if="selectedCourierCompany")
          v-form(ref="form")
            .easyparcel(v-if="selectedCourierCompany == 'easyparcel'")
              template(v-if="couriers.length == 1 && couriers[0].disabled")
                //- Easyparcel error
                v-layout.pa-2
                  v-card.my-auto.mx-2(flat)
                    v-img(:src="require('@/assets/images/logo_easyparcel_small.png')" width="48" height="48")
                  v-col.mx-2
                      div.error--test.font-weight-bold {{ couriers[0].title }}
              template(v-else)
                div.s1.textColorMethod--text.mt-5.mx-5 Choose Courier
                div.red--text.mt-4.body-2(v-if="errorMessage") {{ errorMessage }} 
                v-card.ma-4.text-left.elevation-0.mx-5(style="border:1px solid var(--v-basic300)") 
                  v-list.pa-0
                    v-list-item-group(v-model='selectedCourierIndex', color='primary')
                      template(v-for='(courier, index) in couriers')
                        v-divider.basic300(v-if="index != 0")
                        v-list-item(v-slot:default='{ active, toggle }')
                          v-layout
                            v-card.my-auto(flat)
                              v-img(:src="require(`@/assets/images/couriers/${courier.title}.png`)"
                                    width="48" height="48")
                            v-col.mx-2
                              div {{ courier.title }}
                              div.grey--text {{ courier.meta_data.delivery }}
                              div.font-weight-bold {{ courier.fee | displayPrice }}

                          v-list-item-action
                            v-btn(icon)
                              eva-icon(:name="active? 'checkmark-square-2': 'square-outline'"
                                      :fill="active? $vuetify.theme.themes[$theme].primary500 : $vuetify.theme.themes[$theme].basic"
                                      height="20")

                div.s1.primary--text.mt-9.mb-3.mx-4 Set Shipping Date
                div.mx-0
                  v-date-picker.mb-4(v-model="shippingDate" :min="startDate" header-color="basic100" color="info400" style="width:100%")
            
            .zepto.text-center(v-if="selectedCourierCompany == 'zepto'")
              template(v-if="couriers.length == 1 && couriers[0].disabled")
                //- Zepto error
                v-layout.pa-2
                  v-card.my-auto.mx-2(flat)
                    v-img(:src="require('@/assets/images/icon_zepto.png')" width="48" height="48")
                  v-col.mx-2
                      div.error--test.font-weight-bold {{ couriers[0].title }}
              template(v-else)
                div.caption.mt-4 Estimated Price:
                div.font-weight-bold
                  | {{ couriers[selectedCourierIndex].fee | displayPrice }}
                  |  ( {{ couriers[selectedCourierIndex].meta_data.distance }} km )
                div.s1.primary--text.mt-9.mb-3.mx-4 Set Shipping Date
                div.mx-0
                  v-date-picker.mb-4(
                    header-color="basic100"
                    v-model="shippingDate" :min="startDate"
                    color="info400" 
                    style="width:100%"
                  )

                div.s1.primary--text.mt-9.mb-3.mx-5 Set Shipping Time
                div.mx-5.mb-9
                  v-text-field(
                    v-model="shippingTime"
                    hide-details dense outlined readonly
                    background-color="basic200" height="40"
                    @click="openPicker=!openPicker"
                    :append-icon="!openPicker ? 'mdi-chevron-down' : 'mdi-chevron-up'"
                  )
                  v-card.elevation-0(v-if="openPicker" style="border:1px solid var(--v-basic400)")
                    v-row.ma-0(width="100%" )
                      v-col.border-bottom
                        p.text-center.mb-0.s1.textColorHint--text Hr
                      v-col.border-bottom.border-x
                        p.text-center.mb-0.s1.textColorHint--text Min
                      v-col.border-bottom
                        p.text-center.mb-0.s1.textColorHint--text Am/Pm
                    v-row.ma-0(width="100%" )
                      v-col.pa-0
                        v-list.pa-0(max-height="300px" style="overflow-y:scroll;")
                          v-list-item.point-cursor(
                            :style="hour == h ? 'background-color: var(--v-info400);': ''" 
                            v-for="h in 12" :key="h" @click="hour=h; changeTime()"
                          )
                            v-list-item-content.text-center
                              p.mb-0.s1(:class="{ 'basic100--text': hour == h }") {{h | twoDigit}}
                      v-col.pa-0.border-x
                        v-list.pa-0(max-height="300px" style="overflow-y:scroll;")
                          v-list-item.point-cursor(
                            :style="min == m-1 ? 'background-color: var(--v-info400);': ''"
                            v-for="m in 60" :key="m-1" @click="min=m-1; changeTime()"
                          )
                            v-list-item-content.text-center
                              p.mb-0.s1(:class="{ 'basic100--text': min == m-1 }") {{m-1 | twoDigit}}
                      v-col.pa-0
                        v-list.pa-0(max-height="300px" style="overflow-y:scroll;")
                          v-list-item.point-cursor(:style="ampm == 'AM' ? 'background-color: var(--v-info400);': ''" @click="ampm='AM'; changeTime()")
                            v-list-item-content.text-center
                              p.mb-0.s1(:class="{ 'basic100--text': ampm == 'AM' }") AM
                          v-list-item.point-cursor(:style="ampm == 'PM' ? 'background-color: var(--v-info400);': ''" @click="ampm='PM'; changeTime()")
                            v-list-item-content.text-center
                              p.mb-0.s1(:class="{ 'basic100--text': ampm == 'PM' }") PM

        v-card-actions.px-4
          v-spacer
          v-btn(text @click='showModal = false')
            .button-Aa-small.primary400--text| {{ $t('Cancel') }}
          v-btn(depressed color="textColorAccent" height="32" :loading="isLoading" :disabled="!couriers[selectedCourierIndex] || !shippingTime" @click='clickSave')
            .button-AA-small.basic100--text| {{ $t('ship_parcel') }}
    .modals
      y-dialog(v-model="openBillWindowDialog" width="400px" persistent)
        v-card
          v-card-title Please pay to proceed
          v-card-text.px-6
            div You will be redirected to a payment page after clicking 'Pay Now' button. Please close that page after payment is completed.
          v-card-actions
            v-spacer
            v-btn(text @click="$router.push('/admin/settings/zeptoexpress')")
              .button-Aa-small.primary400--text View job list
            v-btn.mr-2(color='textColorAccent' depressed height=32 @click='openPaymentPage()')
              .button-AA-small.basic100--text Pay now

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'AddShipItemDialog',
  props: ['open', 'parentLead'],
  data: () => ({
    hour:'0',
    min:'0',
    ampm:'AM',
    openPicker: false,
    billUrl: '',
    openBillWindowDialog: false,
    isFetching: false,
    courierCompanySelections: [],
    selectedCourierCompany: null,
    selectedCourierIndex: null,
    errorMessage: '',
    couriers: [],
    shippingDate: new Date().toISOString().substr(0, 10),
    startDate: new Date().toISOString().substr(0, 10),
    shippingTime: '00:00:00',
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  filters: {
    twoDigit(value) {
      if(value<10){
        value='0'+value
      }
      return value
    }
    // fullTimeFormat(value){
    //   var hour = value.slice(0, 2)
    //   var min = value.slice(3, 5)
    //   var ampm = ''
    //   if (hour < 12) {
    //     ampm = 'AM'
    //   }else{
    //     ampm = 'PM'
    //   }
    //   hour = (this.hour % 12) || 12;
    //   return this.$options.filters.twoDigit(hour)+':'+this.$options.filters.twoDigit(min)+' '+ampm
    // }
  },
  computed: {
    ...mapGetters({
      shipments: 'orders/getShipments'
    }),
    lead: {
      get() {
        return this.parentLead
      },
      set(newValue) {
        this.$emit('update:parentLead', newValue)
      }
    },
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    selectedCourierCompany (val) {
      this.fetchCourierFee(val)
    }
  },
  mounted () {
    if (this.shipments.easyparcel) {
      const newSelection = {
        id: 'easyparcel',
        image: require('@/assets/images/logo_easyparcel_small.png')
      }
      this.courierCompanySelections.push(newSelection)
    }
    if (this.shipments.zepto) {
      const newSelection = {
        id: 'zepto',
        image: require('@/assets/images/icon_zepto.png')
      }
      this.courierCompanySelections.push(newSelection)
    }

    // if (this.courierCompanySelections.length == 1) {
    //   this.selectedCourierCompany = this.courierCompanySelections[0].id
    //   this.fetchCourierFee(this.selectedCourierCompany)
    // }

    this.hour = this.shippingTime.slice(0, 2)
    if (this.hour < 12) {
      this.ampm = 'AM'
    }else{
      this.ampm = 'PM'
    }
    this.hour = (this.hour % 12) || 12;
    this.min = this.shippingTime.slice(3, 5)

  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    openPaymentPage () {
      window.open(this.billUrl, '_blank')
    },
    changeTime(){
      var hrs = this.hour
      var mins = this.min
      if (this.ampm=='PM') {
        if (hrs < 12) {
          hrs = hrs + 12
        }
        return this.shippingTime = this.$options.filters.twoDigit(hrs)+':'+this.$options.filters.twoDigit(mins)+':00'
      }else if (this.ampm=='AM') {
        if (hrs == 12) {
          hrs = hrs - 12
        }
        return this.shippingTime = this.$options.filters.twoDigit(hrs)+':'+this.$options.filters.twoDigit(mins)+':00'
      }
    },
    fetchCourierFee (courierCompany) {
      this.isFetching = true
      this.$axios.get(`/shipping/fees/${this.lead.pid}/${courierCompany}`)
        .then((response) => {
          this.couriers = response.data
          if (this.couriers.length === 1 && !this.couriers[0].disabled) {
            this.selectedCourierIndex = 0
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.message) {
            this.errorMessage = e.response.data.message
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    clickSave() {
      // Patch shipping object with required data by each shipper
      if (!this.$refs.form.validate()) {
        return
      }
      let params = {}
      this.isLoading = true
      const courier = this.couriers[this.selectedCourierIndex]
      if (this.selectedCourierCompany == 'easyparcel') {
        params = {
          fee: courier.fee,
          shipping_method: 'easyparcel',
          pickup_date: this.shippingDate,
          meta_data: courier.meta_data,
          signature: courier.signature
        }
      } else if (this.selectedCourierCompany == 'zepto') {
        params = {
          fee: courier.fee,
          shipping_method: 'zepto',
          pickup_date: this.shippingDate,
          pickup_time: this.shippingTime,
          meta_data: courier.meta_data,
          signature: courier.signature
        }
      } else if (this.selectedCourierCompany == 'lalamove') {
          params = {
            fee: courier.fee,
            shipping_method: 'lalamove',
            meta_data: courier.meta_data,
            signature: courier.signature
          }
      } else {
        this.showMessage(['error', this.$t('error_message.this_method_not_supported')])
        return
      }
      if (this.lead.shipping) {
        this.axios.patch(`/shipping/shippings/${this.lead.shipping.id}/`, params)
          .then(() => {
            this.axios.get(`/leads/${this.lead.pid}/`, this.customer)
            .then(resp => {
              this.lead = resp.data
              this.$set(this.lead, 'shipping', resp.data.shipping)
            })
            if (['easyparcel', 'zepto'].includes(this.selectedCourierCompany)){
              this.submitShipping()
            }
          })
          .catch(() => {
            this.isLoading = false
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
        return
      }
      params.lead = this.lead.id
      this.axios.post(`/shipping/shippings/`, params)
        .then(() => {
          this.axios.get(`/leads/${this.lead.pid}/`, this.customer)
          .then(resp => {
            this.lead = resp.data
            this.$set(this.lead, 'shipping', resp.data.shipping)
          })
          if (['easyparcel', 'zepto'].includes(this.selectedCourierCompany)){
            this.submitShipping()
          }
        })
        .catch(() => {
          this.isLoading = false
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    submitShipping(){
      // Let back end handles shipping
      this.axios.post(`/leads/${this.lead.pid}/submit_shipping`)
        .then(resp => {
          if (this.selectedCourierCompany == 'zepto') {
            this.billUrl = resp.data.bill_url
            if (this.billUrl) {
              this.openBillWindowDialog = true
            } else {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
              this.isProcessing = false
            }
            return
          }
          this.showMessage(['success', `Request sent to ${this.lead.shipping.shipping_method}`])
          this.$set(this.lead.shipping, 'status', 'pending')
          // this.lead.shipping.status = 'pending'
          this.showModal = false
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.message) {
            this.showMessage(['error', e.response.data.message])
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .finally(() => {
          this.isLoading = false
        })

    }
  }
}
</script>

<style scoped>
.border-bottom{
    border-bottom: 1px solid var(--v-basic400);
    border-radius: 0 !important;
}
.border-x{
  border-left: 1px solid var(--v-basic400);
  border-right: 1px solid var(--v-basic400);
}
.currentTime{
  background-color: var(--v-info400);
  color: white !important;
}
.point-cursor{
  cursor: pointer;
}
div >>> .v-date-picker-title__year{
    display: none;
}
div >>> .v-date-picker-title__date {
    display: none;
}
div >>> .v-picker__title {
    color: var(--v-primary500);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 0;
}
div >>> .v-picker__body{
  width: 100% !important;
}
div >>> .v-picker__title__btn{
  /* border-top: 1px solid var(--v-basic300); */
  border-bottom: 1px solid var(--v-basic300);
  padding: 8px 0;
  margin:0;
}
div >>> .v-date-picker-header{
  border-top: 1px solid var(--v-basic300);
  border-bottom: 1px solid var(--v-basic300);
}
div >>> .v-time-picker-title__time{
  color: black
}
div >>> .v-time-picker-title__ampm{
  color: black;
  margin-bottom:0;
}
div >>> .v-time-picker-title{
    border-bottom: 1px solid var(--v-basic300);
    border-top: 1px solid var(--v-basic300);
}
div >>> .v-date-picker-table th {
    font-size: 15px;
    color:var(--v-textColorHint) !important;
}
div >>> .v-date-picker-table--date .v-btn {
    height: 32px;
    width: 32px;
    font-size: 15px !important;
    font-weight: 600;
    border-radius: 4px !important;
}
div >>> .v-date-picker-table__current{
  border: 1px solid var(--v-primary);
  /* color: var(--v-primary); */
  background-color: var(--v-primaryT08);
}
div >>> .theme--light.v-btn.v-btn--disabled {
    color:var(--v-textColorHint) !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
div >>> .v-date-picker-table--month td .v-btn {
    margin: 0 auto;
    max-width: 140px;
    min-width: 40px;
    width: 100%;
    font-size: 15px !important;
    font-weight: 600 !important;
}
div >>> .v-date-picker-years {
    font-size: 15px;
    font-weight: 600;
    height: 290px;
    list-style-type: none;
    overflow: auto;
    text-align: center;
}
</style>

<i18n>
{
  "en": {
    "manage_shipping": "Manage Shipping",
    "ship_parcel": "Ship parcel"
  },
  "id": {
    "manage_shipping": "Kelola Pengiriman",
    "ship_parcel": "Kirim Paket"
  }
}
</i18n>
